﻿package com.mgacreative.hotelru.domain.repository

import com.mgacreative.hotelru.core.network.SupabaseNetworkClient
import com.mgacreative.hotelru.domain.model.Guest
import io.github.jan.supabase.postgrest.postgrest

class GuestRepository(private val networkClient: SupabaseNetworkClient) {
    suspend fun createGuest(guest: Guest): Guest? {
        return try {
            networkClient.client.postgrest["guests"]
                .insert(guest) {
                    select()
                }
                .decodeSingleOrNull<Guest>()
        } catch (e: Exception) {
            println("GUEST_REPO_ERROR: ${e.message}")
            e.printStackTrace()
            networkClient.handleError(e)
            null
        }
    }
    
    suspend fun updateGuest(guest: Guest): Guest? {
        return try {
            networkClient.client.postgrest["guests"]
                .update(guest) {
                    filter { eq("id", guest.id ?: "") }
                    select()
                }
                .decodeSingleOrNull<Guest>()
        } catch (e: Exception) {
            e.printStackTrace()
            networkClient.handleError(e)
            null
        }
    }
}

